import {observable, action, runInAction} from 'mobx'
import {json, get} from '../../../../utils/ajax'
import {findChildren, handleSeerchAndPage, setStore, ValueObjToObj, formatParams} from '../../../../utils/Utils'
import {message} from 'antd'

class EPCCatalogVerificationStare {
    @observable list//主页面数据
    @observable pagination//备件发布页面分页
    @observable searchFields//备件发布页面搜索条件
    @observable sparePartsRelwaseList//备件发布页面数据
    @observable saveRowData//保存点击备件发布当行数据
    @observable categoryData//保存备件发布类别的值
    @observable categoryId//保存选中类别的id
    @observable mainGroupId//保存选中主组的id
    @observable groupingDataId//保存选中分组的id
    @observable mainGroupData//保存备件发布主组的值
    @observable groupingData//保存备件发布分组的值
    @observable selectedRowKeysId//保存发布未发布选中的id
    @observable publicationStatus//保存发布状态
    @observable showDrawer//显示抽屉
    @observable importReturnData//导入返回数据
    @observable pictureHeight//中间内容的高度
    @observable leftHeight//左边内容的高度
    @observable rightHeight//右边内容的高度


    //备件目录
    @observable oneLevelMenu//一级目录的数据
    @observable twoLevelMenu//二级目录的数据
    @observable twoLeveLoading//二级目录加载数据
    @observable twoMenu//三级目录的数据
    @observable threeLeveLoading//三级目录的数据
    @observable photos//图片
    @observable result//四级目录的数据
    @observable resultLoading//四级目录加载数据
    @observable searchValue//搜索框的值
    @observable searchList//搜索出来的数据
    @observable searchLoading//搜索出来数据的加载
    @observable sparePartNumberLoading//点击备件出来数据的加载
    @observable addHotList//前台热点回显
    @observable selectTwoMenu//选择的二级目录
    @observable selectThreeMenu//选择的三级目录
    @observable selectFourMenu//点击的四级目录
    @observable hotGrade//表格回显热点标号
    @observable selectMenu//点击零件定位
    @observable oneMenu//当前选择的一级目录
    @observable showTree//根据物料号查询多根树的模态框
    @observable treeRecord//点击的物料号
    @observable treeLoading//Loading
    @observable showSixPhotos//备件信息图片模态框
    @observable selectResult//选中右侧的表格项
    @observable showPhoto//显示大图的模态框
    @observable selectPhoto//当前显示的大图
    @observable showBreakPoint//断点模态框
    @observable breakPointDetail//断点信息
    @observable threeId//选择的三级目录id
    @observable replaceDetail//替换信息
    @observable showReplace //显示替换模态框
    @observable allHotList //所有热点列表，用来回显
    @observable isShowPartDetail
    @observable partDetail //备件详情
    @observable threeLevelMenuClickRow //三级目录点击行的数据
    @observable rightUpperTableClickRow //四级目录点击行的数据
    @observable applicableModels //适用车型
    @observable searchListModalVisible//控制搜索框的隐藏和显示
    @observable sparePartNumberModalVisible//控制点击右侧备件隐藏和显示
    @observable materialNosStatus//发布取消时传给后台选中的物料号
    @observable twoTrackMainList//回显二轨件详情下拉列表
    @observable editTwoTrackMainData//回显二轨件详情数据
    @observable twoTrackDisplayModel//二轨件模态框显示状态
    @observable twoTrackMainModel//二轨件模态框显示状态
    @observable shoppingModel//购物车模块
    @observable shoppingRowData//点击行数据
    @observable editField//购物车回显
    @observable expandedLeftRowKeys//
    @observable sparePartNumberList//存放备件详情信息

    constructor() {
        this.loading = false
        this.list = []
        this.sparePartsRelwaseList = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.page = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.saveRowData = {}
        this.searchFields = {
            spareNo: '',
            spareName: '',
            releaseStatus: '',
            category: '',
            mainGroup: '',
            grouping: '',
        }
        this.categoryData = []
        this.categoryId = ''
        this.mainGroupData = []
        this.groupingData = []
        this.mainGroupId = ''
        this.groupingDataId = ''
        this.selectedRowKeysId = []
        this.publicationStatus = ''
        this.showDrawer = false
        this.importReturnData = []

        //备件目录
        this.oneLevelMenu = []
        this.twoLevelMenu = []
        this.twoLeveLoading = false
        this.threeLeveLoading = false
        this.resultLoading = false
        this.searchLoading = false
        this.sparePartNumberLoading = false
        this.twoMenu = []
        this.photos = []
        this.result = []
        this.searchValue = ''
        this.searchList = []
        this.addHotList = []
        this.selectThreeMenu = ''
        this.selectFourMenu = ''
        this.selectMenu = ''
        this.oneMenu = ''
        this.selectTwoMenu = ''
        this.hotGrade = ''
        this.showTree = false
        this.treeRecord = {}
        this.treeLoading = false
        this.showSixPhotos = false
        this.selectResult = {}
        this.showPhoto = false
        this.selectPhoto = ''
        this.showBreakPoint = false
        this.breakPointDetail = []
        this.threeId = ''
        this.replaceDetail = []
        this.showReplace = false
        this.allHotList = []
        this.isShowPartDetail = false
        this.partDetail = {}
        this.threeLevelMenuClickRow = {}
        this.rightUpperTableClickRow = {}
        this.applicableModels = []
        this.pictureHeight = 0
        this.leftHeight = 0
        this.rightHeight = 0
        this.searchListModalVisible = false
        this.sparePartNumberModalVisible = false
        this.materialNosStatus = []
        this.twoTrackMainList = []
        this.editTwoTrackMainData = {}
        this.twoTrackDisplayModel = false
        this.twoTrackMainModel = false
        this.shoppingModel = false
        this.shoppingRowData = {}
        this.editField = {}
        this.expandedLeftRowKeys = []
        this.sparePartNumberList = []
    }

    /**
     * 初始化页面
     */
    @action
    initListPage = async (page) => {
        this.loading = true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc/enabledCarseriesCatalogs`, {
            page: page - 1,
            carseriesName: '',
            size: this.page.pageSize
        })
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.list = res || []
            this.page = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
        })
    }

    /**
     * 点击备件发布时获取当行数据
     * @param record
     */
    @action
    release = (record) => {
        this.saveRowData = record
    }

    /**-------------------------------------------备件发布--------------------------------------------------*/
    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            for (let [key, value] of Object.entries(obj)) {
                this[key] = value
            }
        }
    }


    @action
    onFieldsChange = (changedFields) => {
        this.searchFields = {...this.searchFields, ...ValueObjToObj(changedFields)}
    }

    /**
     * 初始化备件发布页面
     * @param page
     * @returns {Promise<void>}
     */
    @action
    initSparePartsRelwaseData = async (page) => {
        this.loading = true
        if (this.searchFields.releaseStatus === undefined || this.searchFields.category === undefined || this.searchFields.mainGroup === undefined || this.searchFields.grouping === undefined) {
            this.searchFields.releaseStatus = ''
            this.searchFields.category = ''
            this.searchFields.mainGroup = ''
            this.searchFields.grouping = ''
        }
        let search = handleSeerchAndPage(page, this.pagination, this.searchFields)
        search.size = this.pagination.pageSize
        search[`search.category`] = this.categoryId
        search[`search.mainGroup`] = this.mainGroupId
        search[`search.grouping`] = this.groupingDataId
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/querySparePartsByMapForPage/carseriesCode?carseriesCode=${this.saveRowData.carSeriesCode}`, search)
        runInAction(() => {
            this.sparePartsRelwaseList = res.content || []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            this.selectedRowKeysId = []
            this.loading = false
        })
    }

    /**
     * 获取类别下拉框
     * @returns {Promise<void>}
     */
    @action
    categorySelect = async (value) => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/getCategorySelectValues/carseriesCode?carseriesCode=${this.saveRowData.carSeriesCode}`)
        runInAction(() => {
            this.categoryData = Array.isArray(res) ? res : []
            let data = this.categoryData.find(item => item.codeJoinName === value)
            this.categoryId = data && data.id
        })
        await this.mainGroupValue(this.categoryId)
    }

    /***
     * 获取主组下拉框
     * @param id
     * @returns {Promise<void>}
     */
    @action
    mainGroupValue = async (id) => {
        let ids = id ? id : ''
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/getSubordinateSelectValues/carseriesCode?carseriesCode=${this.saveRowData.carSeriesCode}&&id=${ids}`)
        runInAction(() => {
            this.mainGroupData = Array.isArray(res) ? res : []
        })
    }

    /***
     * 获取分组下拉框
     * @param value
     * @returns {Promise<void>}
     */
    @action
    groupingValue = async (value) => {
        let data = this.mainGroupData.find(item => item.codeJoinName === value)
        this.mainGroupId = data && data.id
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/getSubordinateSelectValues/carseriesCode?carseriesCode=${this.saveRowData.carSeriesCode}&&id=${this.mainGroupId}`)
        runInAction(() => {
            this.groupingData = Array.isArray(res) ? res : []
        })
    }

    @action
    groupingId = async (value) => {
        let data = this.groupingData.find(item => item.codeJoinName === value)
        this.groupingDataId = data && data.id
    }

    /***
     * 重置
     * @returns {Promise<void>}
     */
    @action
    reset = async () => {
        this.searchFields = {
            spareNo: '',
            spareName: '',
            releaseStatus: '',
            category: '',
            mainGroup: '',
            grouping: '',
        }
        this.categoryId = ''
        this.mainGroupId = ''
        this.groupingDataId = ''
        this.mainGroupData = []
        this.groupingData = []
        await this.initSparePartsRelwaseData()
    }

    /***
     * 选中行的ID
     * @param selectedRowKeys
     */
    @action
    selectedRowKeys = (selectedRowKeys) => {
        this.selectedRowKeysId = selectedRowKeys
    }

    /**
     * 选中或取消勾选行数据时触发
     * @param record
     * @param selected
     */
    @action
    onStatusChangeData = (record, selected) => {
        if (selected) {//选中
            this.materialNosStatus.push(record.materialNo)
        } else {//取消
            this.materialNosStatus.remove(record.materialNo)
        }
    }

    /**
     * 全选和取消全选
     * @param data
     * @param selected
     */
    @action
    onSelectAllChangeData(selected, data) {
        if (selected) {//选中
            data.map(item => this.materialNosStatus.push(item.materialNo))
        } else {//取消
            this.materialNosStatus = []
        }
    }

    /***
     * 批量发布
     * @returns {Promise<void>}
     */
    @action
    batchRelease = async (state) => {
        this.publicationStatus = state
    }

    /***
     * 确认发布
     * @returns {Promise<void>}
     */
    @action
    clickBatchRelease = async () => {
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/batchPublishOrCancel/releaseState/${this.publicationStatus}/${this.saveRowData.carSeriesCode}?materialNos=${this.selectedRowKeysId}`)
        await this.initSparePartsRelwaseData()
        runInAction(() => {
            this.materialNosStatus = []
        })
    }

    @action
    onUpload = (arr) => {
        this.importReturnData = arr
        this.showDrawer = true
    }

    @action
    onClose = () => {
        this.showDrawer = false
    }

    /**--------------------------------------------备件目录-------------------------------------------**/

    /**
     * 获取url中的参数并转化为对象
     * @param str
     */
    @action
    getUrlParmas(str) {
        let obj = {}
        str.substring(1).split('&').forEach(item => {
            const arr = item.split('=')
            obj[arr[0]] = decodeURI(arr[1])
        })
        return obj
    }

    /**
     *获取一级目录的数据
     */
    @action
    catalogueIData = async () => {
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)

        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/queryLvOneCatalogs/carseriesCode?carseriesCode=${paramsObj.carseriesCode}`)
        runInAction(() => {
            this.oneLevelMenu = Array.isArray(res) ? res : []
            //获取二级目录
            const id = this.oneLevelMenu[0] ? this.oneLevelMenu[0].id : ''
            const path = this.oneLevelMenu[0] ? this.oneLevelMenu[0].path : ''
            const code = this.oneLevelMenu[0] ? this.oneLevelMenu[0].code : ''
            this.selectOneMenuData(path, id, code)
        })
    }

    /**
     * 通过点击一级目录获取二级目录的数据
     * @param path
     * @param id
     * @param code
     * @returns {Promise<void>}
     */
    @action
    selectOneMenuData = async (path, id, code) => {
        this.twoMenu = []
        this.result = []
        // this.searchList=[]
        this.addHotList = []
        this.selectTwoMenu = ''
        this.selectThreeMenu = ''
        this.selectFourMenu = ''
        // this.selectMenu=''
        this.hotGrade = ''
        this.rightUpperTableClickRow = {}
        this.threeLevelMenuClickRow = {}
        this.twoLeveLoading = true
        this.oneMenu = path
        //获取二级目录参数
        let lv1Id = id
        if (!lv1Id) {
            for (let item of this.oneLevelMenu) {
                if (item.path === path) {
                    lv1Id = item.id
                    break
                }
            }
        }
        let obj = {
            carseriesCode: this.oneLevelMenu[0] ? this.oneLevelMenu[0].carseriesCode : '',
            lv1Id
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/directoryQuerySubordinateTree/carseriesCode?carseriesCode=${obj.carseriesCode}&&lv1Id=${obj.lv1Id}`)
        await this.getPhotoList(lv1Id)
        runInAction(() => {
            this.twoLevelMenu = Array.isArray(res) ? res : []
            this.twoLeveLoading = false
        })
    }

    /**
     * 二级目录的点击事件
     * @param record
     * @param index
     */
    @action
    twoLevelMenuClick = async (record, index) => {
        this.selectTwoMenu = record.path
        this.addHotList = []
        this.result = []
        this.selectFourMenu = ''
        this.hotGrade = ''
        this.rightUpperTableClickRow = {}
        this.threeLevelMenuClickRow = {}
        await this.getThreeLevelMenu(record)
    }

    /**
     * 通过点击二级目录获取三级目录的数据
     * @param record
     */
    @action
    getThreeLevelMenu = async (record) => {
        this.threeLeveLoading = true
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/queryLvThreeCatalogs/carseriesCode?carseriesCode=${paramsObj.carseriesCode}&&lv2Id=${record.id}`)
        runInAction(() => {
            this.twoMenu = Array.isArray(res) ? res : []
            this.threeLeveLoading = false
            this.photos = this.twoMenu.length > 0 && this.twoMenu
            this.selectThreeMenu = this.twoMenu.length > 0 && this.twoMenu.length <= 1 && this.photos[0].path
            this.twoMenu.length > 0 && this.twoMenu.length <= 1 && this.threeLevelMenuClick(this.photos[0])
        })
    }

    /**
     * 获取缩略图集合
     * @param lv1Id
     * @returns {Promise<void>}
     */
    getPhotoList = async (lv1Id) => {
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        const obj = {
            carseriesCode: paramsObj.carseriesCode,
            lv1Id,
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/queryPhotos/carseriesCode?carseriesCode=${obj.carseriesCode}&&lv1Id=${obj.lv1Id}`)
        runInAction(() => {
            this.photos = Array.isArray(res) ? res : []
        })
    }

    /**
     * 点击图片时定位到二级目录上
     * @param item
     */
    @action
    twoLocation = (item) => {
        const path = item.figureNo.split('-')[0]
        let record = {}
        let index = 0
        this.twoLevelMenu.find((v, i) => {    //用find只是可以提前打断遍历
            this.expandedLeftRowKeys = [v.path]
            const same = v.path.split('/').pop() === path
            if (same) {
                record = v
                index = i
            }
            return same
        })
        this.twoLevelMenuClick(record, index)
    }

    /**
     * 三级目录的点击事件
     * @param record
     */
    @action
    threeLevelMenuClick = async (record) => {
        this.rightUpperTableClickRow = {}
        this.threeLevelMenuClickRow = record
        this.addHotList = []
        this.hotGrade = ''
        this.selectThreeMenu = record.path && record.path
        this.resultLoading = true
        this.threeId = record.id
        this.photos = [record.imgUrl || '']
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/querySparePartsByThreeCatalog/carseriesCode?carseriesCode=${paramsObj.carseriesCode}&&lv3Id=${record.id}`)
        runInAction(() => {
            this.result = Array.isArray(res) ? res : []
            this.resultLoading = false
            this.allHotList = this.result.reduce((acc, cur) => {
                let list = Array.isArray(cur.coordinateList) ? cur.coordinateList.map(item => {
                    return {...item, grade: cur.grade}
                }) : []
                return acc.concat(list)
            }, [])
        })
    }

    /**
     * 获取到input输入的值
     * @param value
     */
    @action
    searchValueClickData = (value) => {
        this.searchValue = value
    }

    /**
     * 查询
     */
    @action
    searchValueData = async () => {
        if (!this.searchValue) {
            message.warning(`请输入搜索条件`)
            return
        }
        this.searchLoading = true
        this.searchListModalVisible = true
        this.sparePartNumberModalVisible = false
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        let obj = {content: this.searchValue}
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/querySparePartsByCarserieaCodeAndContent/carseriesCode?carseriesCode=${paramsObj.carseriesCode}`, obj)
        runInAction(() => {
            this.searchList = Array.isArray(res) ? res : []
            this.searchLoading = false
        })
    }

    /**点击备件查询详情**/
    @action
    sparePartNumber = async (record) => {
        this.sparePartNumberLoading = true
        this.sparePartNumberModalVisible = true
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/queryDetailedInformationBasedOnSpareParts/carseriesCode`, {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/checkTheDetailedInformationOfTheSparePartNumber`, {
            [`search.lv3Id`] : record.catalogId,
            [`search.carseriesCode`]:paramsObj.carseriesCode,
            [`search.vin`]:paramsObj.vin,
            [`search.grade`]:record.grade
        })
        runInAction(() => {
            this.sparePartNumberList = Array.isArray(res) ? res : []
            this.sparePartNumberLoading = false
        })
    }

    /**
     * 右下表格的点击事件
     * @param record
     */
    @action
    rightUpperTableClick = async (record) => {
        this.threeLevelMenuClickRow = {}
        this.rightUpperTableClickRow = record
        this.addHotList = record.coordinateList
        this.selectFourMenu = record.id
        this.hotGrade = ''
        this.searchListModalVisible = false
        // await this.toconfigure(record)
    }

    // /**
    //  * 适用车型
    //  * @param record
    //  * @returns {Promise<void>}
    //  */
    // @action
    // toconfigure = async (record) =>{
    //     let obj = {
    //         carseriesCode:record.carseriesCode,
    //         materialNo:record.materialNo,
    //     }
    //     const res =  await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/getCarConfigByCarAndMaterialNo`, obj)
    //     runInAction(()=>{
    //         let list = []
    //         let data = Array.isArray(res)?res:[];
    //         data.map(item=>
    //             list.push(`${item.allocation} ${item.displacement} ${item.driveType} ${item.modelYear} ${item.power} ${item.transType}`)
    //         )
    //         this.applicableModels=list
    //     })
    //
    // }

    /**
     * 热点定位
     * @param hot
     */
    @action
    editPosHot = (hot) => {
        this.addHotList = [hot]
        this.selectFourMenu = ''
        this.hotGrade = hot.grade
    }

    /**
     * 点击零件定位到指定的目录去
     * @param record
     */
    @action
    locationData = async (record) => {
        this.selectMenu = record.spareNo
        const paths = record.threeCatalogPath.split('/')
        const oneMenu = `/${paths[1]}`
        const twoMenu = `${oneMenu}/${paths[2]}`
        const threeMenu = record.threeCatalogPath
        const code1 = `${paths[1]}`
        const code2 = `${paths[2]}`
        const code3 = `${paths[3]}`
        if (threeMenu === this.selectThreeMenu) {
            //如果当前就是要定位的三级目录则return
            this.queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode(record.carseriesCode, code1)
            await this.queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode3ji(record.carseriesCode, code2)
            await this.changeExpandedLeftRowKeys(record.threeCatalogPath)
            await this.changeExpandedLeftRowKeys2(record)
            return
        }
        //定位一级目录、获取二级目录
        if (oneMenu !== this.oneMenu) {
            await this.selectOneMenuData(oneMenu)
        }
        // 定位二级目录
        let obj = {}
        let index = -1
        this.twoLevelMenu.find((item, i) => {
            if (item.path === twoMenu) {
                obj = item
                index = i
            }
            return item.path === twoMenu    //这里只是在找到后打断遍历提高效率
        })
        if (index === -1) {
            return
        }
        if (this.selectTwoMenu[0] !== twoMenu) {
            await this.twoLevelMenuClick(obj, index)
        }
        //定位三级目录this.twoMenu
        const item = this.twoMenu.find(i => i.path === record.threeCatalogPath)
        await this.threeLevelMenuClick(item)
        let data = this.result.find(item => item.id === record.id)
        await this.rightUpperTableClick(data)
    }

    /**
     * 查询多根树
     * @param record
     * @returns {Promise<void>}
     */
    @action
    getTree = async (record, e) => {
        this.showTree = true
        this.treeRecord = record
        this.treeLoading = true

        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/getFrontPurchaseStatus/${record.materialNo}`,)
        runInAction(() => {
            this.treeLoading = false
            this.treeDate = res.content ? findChildren(res.content) : []
        })
        // const pagination = {
        //     ...this.state.pagination,
        //     total:res.totalElements || 0, //从后台获取有多少条数据
        //     current,
        // };
    }

    /**
     * 获取备件详情数据
     */
    @action
    getPartDetail = async (id, e) => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/sparePart/getBySpareNo/id/${id}`)
        runInAction(() => {
            // let entryTimeEnd = res.entryTimeEnd===null?'时间':moment(res.entryTimeEnd)
            // let entryTimeStart = res.entryTimeStart===null?'时间':moment(res.entryTimeStart).format('YYYY-MM-DD')
            this.partDetail = res
            // this.partDetail.time=`${entryTimeStart}-${entryTimeEnd}`
            this.isShowPartDetail = true
        })
    }

    /**
     * 查询图片信息
     * @param record
     * @param e
     */
    @action
    getPhotoData = (record, e) => {
        this.showSixPhotos = true
        this.selectResult = record
    }

    /**
     * 查询断点信息
     * @param record
     * @param e
     * @returns {Promise<void>}
     */
    @action
    getBreakPointData = async (record, e) => {
        this.showBreakPoint = true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/getBreakPointInfoByMaterialNo/${record.materialNo}`)
        runInAction(() => {
            this.breakPointDetail = Array.isArray(res) ? res : []
        })
    }

    /**
     * 查询替换信息
     * @param record
     * @param e
     * @returns {Promise<void>}
     */
    @action
    editGetReplaceInfo = async (record, e) => {
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        const obj = {
            [`search.bySpareNo`]: record.spareNo,
            [`search.carseriesCode`]: paramsObj.carseriesCode,
            [`search.catalogId`]: this.threeId
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/getChangeInfoByMaterialNo`, obj)
        runInAction(() => {
            this.replaceDetail = Array.isArray(res) ? res : []
            this.showReplace = true
        })
    }

    /**
     * 查询二轨件详情
     * @param record
     * @param letter
     */
    @action
    EditTwoTrackDisplay = async (record, letter) => {
        let search = {};
        search[`search.catalogSparePartId`] = record.id;
        search[`search.trackLetter`] = letter;
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/twoTrack/getTwoTrackInfoList:search`, search);
        runInAction(() => {
            this.twoTrackMainList = Array.isArray(res) ? res : []
            if (this.twoTrackMainList.length > 1) {
                this.twoTrackDisplayModel = true
            } else {
                this.editMultiTrackParts(record, 0)
            }
        })
    }

    /**
     * 显示模态框
     *
     */
    @action
    editMultiTrackParts = (record, index) => {
        this.twoTrackDisplayModel = false
        this.twoTrackMainModel = true
        let list = this.twoTrackMainList[index].list || []
        let arr = []
        let name = ['二轨件', '三轨件', '四轨件', '五轨件', '六轨件', '七轨件', '八轨件', '九轨件',]
        for (let i = 0; i < list.length; i++) {
            arr.push({
                railFittings: name[i],
                manyTrackName: `manyTrackName${i}`,
                manyTrackNo: `manyTrackNo${i}`,
                manyTrackSupplier: `manyTrackSupplier${i}`,
                manyTrackSupplierNo: `manyTrackSupplierNo${i}`
            })
        }
        this.twoTrackMainData = arr

        let arr2 = []
        for (let i = 0; i < list.length; i++) {
            arr2.push({
                [`manyTrackName${i}`]: list[i].manyTrackName,
                [`manyTrackNo${i}`]: list[i].manyTrackNo,
                [`manyTrackSupplier${i}`]: list[i].manyTrackSupplier,
                [`manyTrackSupplierNo${i}`]: list[i].manyTrackSupplierNo
            })
            this.editTwoTrackMainData = {...this.editTwoTrackMainData, ...arr2[i], ...this.twoTrackMainList[index]}
        }
    }

    /**
     * 点击购物车
     */
    @action
    clickShoppingData = (record) => {
        this.shoppingModel = true
        this.shoppingRowData = record
    }

    @action
    changedField = (changedFields) => {
        this.editField = {...this.editField, ...ValueObjToObj(changedFields)}
    }

    /**
     * 添加购物车
     *
     * @returns {Promise<void>}
     */
    @action
    addShoppingData = async () => {
        this.shoppingModel = false
        let data = {
            serviceCodeList: [],
            materialNo: this.shoppingRowData.materialNo ? this.shoppingRowData.materialNo : '',
            spareName: this.shoppingRowData.spareName ? this.shoppingRowData.spareName : '',
            spareNo: this.shoppingRowData.spareNo ? this.shoppingRowData.spareNo : '',
            orderNumber: this.editField.orderNumber
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/shoppingCar/addToShoppingCar`, data)
        if (res.status) {
            message.success(`添加成功！`)
        } else {
            message.warning(`添加失败！`)
        }
        runInAction(() => {
            this.editField = {}
            const item = this.twoMenu.find(i => i.path === this.shoppingRowData.path)
            if (item) {
                this.threeLevelMenuClick(item)
            }
        })
    }

    /**
     * 展开的行变化时触发
     * @param expandedRows
     */
    @action
    changeExpandedLeftRowKeys = (expandedRows) => {
        this.expandedLeftRowKeys = expandedRows
    }

    /**
     * 根据车系code和目录code查询1级目录
     * @param record
     */
    @action
    queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode = async (carseriesCode, code) => {
        this.loading = true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode2?carCode=${carseriesCode}&code=${code}`)
        runInAction(() => {
            this.loading = false
            this.selectOneMenuData2(res)
        })
    }

    /**
     * 通过点击一级目录获取二级目录的数据
     * @param path
     * @param id
     * @param code
     * @returns {Promise<void>}
     */
    @action
    selectOneMenuData2=async (res1)=>{
        this.twoMenu = []
        this.result = []
        this.addHotList = []
        this.selectTwoMenu = ''
        this.selectThreeMenu = ''
        this.hotGrade = ''
        this.rightUpperTableClickRow = {}
        this.threeLevelMenuClickRow = {}
        this.twoLeveLoading = true
        this.oneMenu = res1.path.split('/')[0]
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/directoryQuerySubordinateTree/carseriesCode?carseriesCode=${res1.carseriesCode}&&lv1Id=${res1.pid}`)
        await this.getPhotoList(res1.id)
        runInAction(() => {
            this.twoLevelMenu = Array.isArray(res) ? res : []
            this.twoLeveLoading = false
        })
    }

    /**
     * 根据车系code和目录code查询3级目录
     * @param record
     */
    @action
    queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode3ji = async (carseriesCode, code) => {
        this.loading = true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode?carCode=${carseriesCode}&code=${code}`)
        runInAction(() => {
            this.loading = false
            this.threeLevelMenuClick(res)
        })
    }

    /**
     * 展开的行变化时触发
     * @param expandedRows
     */
    @action
    changeExpandedLeftRowKeys2 = (record) => {
        this.selectFourMenu = record.id
    }

}

export default new EPCCatalogVerificationStare()



// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/EPC/EPCCatalogVerification/store.js